export const EXPORT_DATASET_TOO_LARGE_MESSAGE = "The data set you selected is too large to export. Please try using the Filters to narrow your search.";

export const DEFAULT_EXPORT_ERROR_MESSAGE = "No data found. Try changing your selected filters and try again.";

export const getExportErrorMessage = (error) => {
  const apiMessage = error?.data?.message || error?.data?.error;

  return apiMessage.includes("Export row limit reached")
    ? EXPORT_DATASET_TOO_LARGE_MESSAGE
    : DEFAULT_EXPORT_ERROR_MESSAGE;
};
